import { render, Suspense } from "@wordpress/element";
import withAppProviders from "withAppProviders";
import Block from "./Block";

const Checkout = ({ attributes }) => {
	return <Block attributes={attributes} />;
};

const VinoCheckout = withAppProviders(Checkout)();

window.addEventListener("DOMContentLoaded", () => {
	const element = document.querySelector(".wp-block-vino-checkout");
	if (element) {
		render(
			<Suspense fallback={<div className="wp-block-placeholder" />}>
				<VinoCheckout />
			</Suspense>,
			element
		);
	}
});
